var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconThumbUp = function SvgIconThumbUp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833313 18.3333H4.16665V8.33333H0.833313V18.3333ZM19.1666 9.16666C19.1666 8.25 18.4166 7.5 17.5 7.5H12.2416L13.0333 3.69166L13.0583 3.425C13.0583 3.08333 12.9166 2.76666 12.6916 2.54166L11.8083 1.66666L6.32498 7.15833C6.01665 7.45833 5.83331 7.875 5.83331 8.33333V16.6667C5.83331 17.5833 6.58331 18.3333 7.49998 18.3333H15C15.6916 18.3333 16.2833 17.9167 16.5333 17.3167L19.05 11.4417C19.125 11.25 19.1666 11.05 19.1666 10.8333V9.16666Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconThumbUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-thumb_up.cea14595901f53211a1560e6e0c1d050.svg";